import { render, staticRenderFns } from "./Yinsi.vue?vue&type=template&id=6c2496d8&scoped=true&"
import script from "./Yinsi.vue?vue&type=script&lang=js&"
export * from "./Yinsi.vue?vue&type=script&lang=js&"
import style0 from "./Yinsi.vue?vue&type=style&index=0&id=6c2496d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2496d8",
  null
  
)

export default component.exports